import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_3111_11024)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.33442 0.927856H10.7752V10.1221C10.7752 14.3856 8.52736 18.9827 4.2638 23.0722L0.507812 20.0704C2.26254 18.0691 5.19192 14.8062 5.26443 10.1366H1.33442V0.927856ZM14.0526 0.927856H23.4933V10.1221C23.4933 14.3856 21.2455 18.9827 16.982 23.0722L13.226 20.0704C14.9807 18.0691 17.8956 14.8062 17.9826 10.1366H14.0526V0.927856Z",
    fill: "#F98864"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_3111_11024" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "24",
      height: "24",
      fill: "white"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }